export const EVENTS = {
  TIS_CRITICAL: "TIS Critical",
  CRITICAL: "Critical",
  INFORMATION: "Information",
  SERVICE: "Service Required"
}
